

























































































































import Vue from 'vue'
import {statusList,appListColumns} from "@/views/console/gateway-list/components/data";
import {
  IotAppEventServiceProxy,
  IotAppMethodServiceProxy, IotAppPropertyServiceProxy,
  IotAppServiceProxy,
  IotAppSettingServiceProxy
} from "@/service-proxies/app-v2/iot-console.service-proxies";
import MethodDrawer from "@/views/console/gateway-list/components/Method.vue";
import SettingDrawer from "@/views/console/gateway-list/components/Setting.vue";
import EventDrawer from "@/views/console/gateway-list/components/Event.vue";
import AttributeDrawer from "@/views/console/gateway-list/components/Attribute.vue";
import HistoryDrawer from "@/views/console/gateway-list/components/History.vue";

const iamsp = new IotAppMethodServiceProxy()
const iapsp = new IotAppPropertyServiceProxy()
const iaesp = new IotAppEventServiceProxy()
const iassp = new IotAppSettingServiceProxy()
const iasp = new IotAppServiceProxy()
export default Vue.extend({
  components: {
    MethodDrawer,
    SettingDrawer,
    EventDrawer,
    AttributeDrawer,
    HistoryDrawer,
  },
  props: {
    gateway:{
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      appListFilter: {
        isOnline: undefined,
        filter: ''
      },
      appList: [],
      currentAppCode: '', // 应用列表行选中
      currentAppId: '', // 应用列表行选中
      currentApp: {}, // 当前选中的app
      leftTableScroll: 0,
      rightTableScroll: 0,
      appListLoading: false,
      currentGatewayCode:'',
      currentGatewayId:''
    }
  },
  computed: {
    gatewayCode(){
      return this.gateway?.code || ''
    },
    appListColumns() {
      return appListColumns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
    statusList() {
      return statusList.map((item) => {
        return {
          ...item,
          label: this.$t(item.label)
        }
      })
    },
  },
  mounted() {
    this.initData()
  },
  created() {
    this.initData()
    this.getAppList()
  },
  destroyed() {
  },
  methods: {
    initData(){
      this.currentGatewayCode = this.gateway.code
      this.currentGatewayId = this.gateway.id
    },
    // 获取应用列表
    async getAppList() {
      this.appList = []
      this.appListLoading = true
      const { isOnline, filter } = this.appListFilter
      let status = String(isOnline) === '1' ? true : String(isOnline) === '0' ? false : undefined
      try {
        let { items } = await iasp.getIotAppList(filter, this.currentGatewayCode, status)
        this.appList = items
        this.currentApp = this.appList.length ? this.appList[0] : {}
        this.currentAppCode = this.appList.length ? this.appList[0].code : ''
        this.currentAppId = this.appList.length ? this.appList[0].id : ''
      } catch (e) {
        console.log(e)
      }
      this.appListLoading = false
    },
    showDrawer() {
      this.$refs.Method.showDrawer()
    },
    showSet() {
      this.$refs.Set.showDrawer()
    },
    showEvent() {
      this.$refs.Event.showDrawer()
    },
    showQuality() {
      this.$refs.Quality.showDrawer()
    },
    showHistory() {
      this.$refs.History.showDrawer()
    },
    async toggleAppStatus(type) {
      let fn = {
        start: iasp.startIotApp.bind(iasp),
        stop: iasp.stopIotApp.bind(iasp)
      }
      await fn[type](this.currentGatewayCode, this.currentAppCode)
      this.$message.success(this.$t('page_resource_pool_success'))
      this.getAppList()
    },
    // 切换app监控状态
    async toggleAppLogMonitoring(type) {
      let params = {
        appCode: this.currentAppCode,
        enabled: type,
        gatewayCode: this.currentGatewayCode
      }
      let fn = iasp.monitorLog.bind(iasp, params)

      await fn()
      this.$message.success(this.$t('page_resource_pool_success'))
      this.getAppList()
    },
    // 表格行点击
    rowClick(record: any, type: string) {
      return {
        on: {
          click: (event: any) => {
            if (type === 'currentGatewayCode') {
              this.currentGatewayCode = record.code
              this.currentGatewayId = record.id
              this.selectedRowKeys = [record.code]
              this.selectGatewayIds = [record.id]
              this.selectedRows = [record]
            } else if (type === 'currentAppCode') {
              this.currentAppCode = record.code
              this.currentAppId = record.id
              this.currentApp = record
            }
            // console.log('行点击：', this.currentGatewayCode, this.selectedRowKeys, this.selectedRows)
          }
        }
      }
    },
    // 同步
    async synchro(child) {
      let params = {
        appCode: this.currentAppCode,
        gatewayCode: this.currentGatewayCode
      }
      let fn = {
        Set: iassp.requestIotSettingMetadata.bind(iassp),
        Quality: iapsp.requestIotPropertyMetadata.bind(iapsp),
        Method: iamsp.requestIotMethodMetadata.bind(iamsp),
        Event: iaesp.requestIotEventMetadata.bind(iaesp)
      }
      await fn[child](params)
      this.$message.success(this.$t('page_resource_pool_success'))
      this.$refs[child].refresh()
    },
  },
  watch:{
    gateway(val) {
      this.initData()
      this.getAppList()
    },
  }
})
